import { lazy } from "solid-js";

// session feature の public surface: Web カメラによる口開き検出セッション (実行中) — /session。
// 検出ループ / 永続化 / PiP HUD などの中身は features/session/{lib,components,state} に閉じ込め、
// 外 (app の route) からは index.ts 経由でしか入れない。
export const SessionPage = lazy(() => import("./pages/session-page"));
// §UC-01-D: カメラ拒否時の再リクエスト案内 (旧 features/calibration から移管、 plan §U2)。
export const PermissionDeniedPage = lazy(() => import("./pages/permission-denied-page"));

// §near-miss raw-capture (ADR 0016 D2/D4、 dev-only): dev capture route が production と完全同一の
// per-frame detection closure を `startFrameLoop` で駆動しつつ observer で観測するため、 public surface
// 経由で読めるようにする。 production composition root は observer を渡さないため treeshake 対象。
/** @public */
export { createDetectionResultHandler } from "./lib/detection-loop";
// §評価ハーネス (issue #76、 dev-only): 既存 detection-machine.ts は referentially transparent な
// pure 関数なので、 shim を作らず public surface 経由で features/eval から読めるようにする。
// production build では features/eval/ 経路が DEV_EVAL ガードで切れるため treeshake 対象。
// `@public` は features/eval/ (後続 unit U10/U13) で consume されるまで knip が unused
// 警告を出すのを抑える宣言 (= 設計上 export 維持が正)。
/** @public */
export type {
  DetectionInput,
  DetectionState,
  DetectionStep,
  DetectionTuning,
} from "./lib/detection-machine";
/** @public */
export {
  DEFAULT_TUNING,
  INITIAL_STATE,
  step as detectionStep,
} from "./lib/detection-machine";
// app-layout のトースト / PiP 内通知の「誤検知」「役に立った」ボタンが叩く mark API。
// 実行中セッションの蓄積 state は features/session/state/ に閉じるため、 外部 (app 層) からは
// この public surface 経由で参照する。
export { markNotificationBad, markNotificationGood } from "./state/session-store";
